import Slide from '../components/Slide';
import { sunlight } from '../data/pages';

export default function Sunlight() {
  const { dataKey, heading, options } = sunlight;
  return <Slide dataKey={dataKey} heading={heading} options={options} />;
}
